import { Component } from 'react'
import { Card, Button, Typography } from 'antd'

const { Text } = Typography

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    // R-audit-2026-10-07 P1:prod 静默 + Sentry 上报(避免 ErrorBoundary 触发后没人知道)
    if (import.meta.env.DEV) {
      console.error('ErrorBoundary caught:', error, info)
    }
    // 动态 import('@sentry/react') 兼容 main.jsx 异步 Sentry 初始化
    import('@sentry/react').then((Sentry) => {
      try {
        Sentry.captureException(error, { extra: { componentStack: info?.componentStack } })
      } catch (_) { /* Sentry 调用失败不阻断主流程 */ }
    }).catch(() => { /* @sentry/react 加载失败(Vite chunk miss 等)不阻断 */ })
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null })
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      // R-audit-2026-10-07 P1:silentFallback(头部 Bell/Modal 抛错时不影响整体布局)
      if (this.props.silentFallback) {
        return null
      }
      return (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          background: '#f5f5f5'
        }}>
          <Card style={{ textAlign: 'center', maxWidth: 500 }}>
            <Text type="danger" style={{ fontSize: 48 }}>⚠</Text>
            <Typography.Title level={4} style={{ marginTop: 16 }}>
              页面出现错误
            </Typography.Title>
            <Text type="secondary" style={{ display: 'block', marginBottom: 24 }}>
              请尝试刷新页面。如果问题持续存在，请联系管理员。
            </Text>
            <Button type="primary" onClick={this.handleReload}>
              刷新页面
            </Button>
          </Card>
        </div>
      )
    }

    return this.props.children
  }
}